import type { FC, SVGProps } from "react";

const PipIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="pip video icon">
      {/* <title>pip video icon</title> */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.45705 2.3999H19.5428C20.6785 2.3999 21.5999 3.32133 21.5999 4.45705V19.5428C21.5999 20.6785 20.6785 21.5999 19.5428 21.5999H4.45705C3.32133 21.5999 2.3999 20.6785 2.3999 19.5428V4.45705C2.3999 3.32133 3.32133 2.3999 4.45705 2.3999ZM10.3934 11.9999H16.7881C17.5669 11.9999 18.1988 12.6317 18.1988 13.4105V17.1721C18.1988 17.9509 17.5669 18.5828 16.7881 18.5828H10.3934C9.6146 18.5828 8.98276 17.9509 8.98276 17.1721V13.4105C8.98276 12.6317 9.6146 11.9999 10.3934 11.9999Z"
        fill={props.fill || "currentColor" || "#F5F5F5"}
      />
    </svg>
  );
};

export default PipIcon;
